import React, { useContext, useEffect, useState } from "react";
import { Roles } from "../utils/userUtil";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { SSOContext } from "../context/SSOContext";
import { PlayerContext } from "../context/PlayerContext";
import { UserContext } from "../context/UserContext";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import logo from "../assets/images/new_ss_logo.png";
import UserService from "../services/UserService";
import SimService from "../services/SimService";
import { LibraryContext } from "../context/LibraryContext";
import SimSessionService from "../services/SimSessionService";
import { getTimeDiffereceInDays, setSimPlayData } from "../utils/utils";
import moment from "moment";
import {
  deleteSimSessionById,
  getSimSessionById,
} from "../services/IndexedDbService";

const SimLoading = () => {
  const history = useHistory();

  const ssoContext = useContext(SSOContext);
  const playerContext = useContext(PlayerContext);
  const userContext = useContext(UserContext);
  const libraryContext = useContext(LibraryContext);
  const [role, setRole] = useState(null);
  const [isSimPlayed, setIsSimPlayed] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [isTokenExpired, setTokenExpired] = useState(false);
  const [isApiCalled, setIsApiCalled] = useState(false);
    const [isSimGet, setIsSimGet] = useState(false);

  useEffect(() => {
    const getSimSessionData = async () => {
      let isSimSessionFoundInLocal = false;
      try {
        const simSessionKey = `${playerContext.playerState.simId}_${
          userContext.user.id
        }_${playerContext.linkId === "" ? "null" : playerContext.linkId}`;
        let savedSimSessionData = await getSimSessionById(simSessionKey);
        const simSessionLastSavedDate = savedSimSessionData?.expiryDate;
        console.debug(
          "Saved Sim Session Data => ",
          savedSimSessionData,
          simSessionLastSavedDate,
          `${playerContext.playerState.simId}_${userContext.user.id}_${
            playerContext.linkId === "" ? "null" : playerContext.linkId
          }`
        );
        let isSimSessionValid = false;
        if (savedSimSessionData) {
          isSimSessionFoundInLocal = true;

          // check if the sim session is still valid or expired
          const simSessionLastDate = moment(simSessionLastSavedDate);
          const dateNow = moment(new Date());
          const timeDifferenceInDays = getTimeDiffereceInDays(
            simSessionLastDate,
            dateNow
          );
          console.debug("Time Difference In Days => ", timeDifferenceInDays);
          //delete sim session if not valid
          if (!(timeDifferenceInDays < 5)) {
            console.debug("Deleting Sim Session Data => ", simSessionKey);
            deleteSimSessionById(simSessionKey);
            savedSimSessionData = null;
          }
        }

        // if sim session not found in indexed db then retrieve from server
        if (!isSimSessionFoundInLocal) {
          const simSession = {
            userId: userContext.user.id,
            simId: playerContext.playerState.simId,
            linkId: playerContext.linkId === "" ? null : playerContext.linkId,
            accountId: ssoContext.accountId,
          };
          const res = await SimSessionService().retrieveSimSessionData(
            simSession
          );
          console.debug("Retrieved Sim Session Data from SB => ", res);
          console.debug("res.simSessionData", res?.simSessionData);
          savedSimSessionData = res
            ? {
                ...res,
                simSessionData: JSON.parse(res.simSessionData),
                id: simSessionKey,
              }
            : null;
        }

        console.debug("Final Saved Sim Session Data => ", savedSimSessionData);

        if (savedSimSessionData) {
          console.debug(
            "playerContext.playerState before updating==>",
            playerContext.playerState
          );
          savedSimSessionData.simSessionData.playerState.media =
            playerContext.playerState?.media;
          savedSimSessionData.simSessionData.playerState.characters =
            playerContext.playerState?.characters;
          savedSimSessionData.simSessionData.playerState.tracks =
            playerContext.playerState?.tracks;

          playerContext.setSimSessionState(savedSimSessionData);
          history.push("/promptPlay");
        } else {
          setTimeout(() => history.push("/play"), 3000);
        }
      } catch (error) {
        console.error("Error retrieving sim session data: ", error);
      }
    };

    if (playerContext.playerState.simId && playerContext.isStoreSimSession) {
      getSimSessionData();
    }
  }, [playerContext.playerState]);

  useEffect(() => {
    let params = queryString.parse(window.location.search);
    if (ssoContext.ssoSimId !== null && !isSimGet) {
      setIsSimGet(true);
      playerContext.getAndPlaySim(
        true,
        ssoContext.ssoSimId,
        ssoContext.linkId ? ssoContext.linkId : "",
        ssoContext.linkAuditId,
        ssoContext.accountId,
        ssoContext.portalSimCode,
        ssoContext.showPreSimFeedbackPage,
        ssoContext.showPostSimFeedbackPage,
        ssoContext.showPreSimQR,
        ssoContext.showPostSimQR
      );
    }
    if (!isApiCalled) {
      if (params["t"]) {
        let data = {
          jwt: params["t"],
          isAdRetrieve: true,
          isAccreditationClient: true,
        };
        setShowLoader(true);
        UserService()
          .verifyJwtSimToken(data)
          .then((response) => {
            if (response.status === 200) {
              console.debug("SimLoading Response Data => ", response.data);
              setSimPlayData(
                userContext,
                ssoContext,
                response.data,
                params["linkAuditId"]
              );
            } else {
              console.error(
                "Error: while verifying JWT Token Or Token invalid!"
              );
              setTokenExpired(true);
            }
          })
          .catch((e) => {
            console.error(e.message);
            setTokenExpired(true);
          });
      } else if (params["s"]) {
        let isSimPlayed = false;
        if (userContext.user) {
          let userRole = userContext.user.roleByRole.roleName;
          SimService()
            .getSimById(params["s"])
            .then((response) => {
              if (response.status === 200) {
                let sim = response.data;
                libraryContext.addSimToLibrary(sim);
                const simStatus = sim.published;
                if (userRole === Roles.Admin) {
                  isSimPlayed = true;
                } else if (userRole === Roles.Client && !simStatus) {
                  isSimPlayed = true;
                } else if (!simStatus) {
                  isSimPlayed = true;
                }
                setIsSimPlayed(isSimPlayed);
                setRole(userRole);
                if (isSimPlayed) {
                  ssoContext.setSsoSimId(params["s"]);
                }
              }
            });
        }
      }
      setIsApiCalled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ssoContext]);

  return (
    <>
      {showLoader && (
        <div className="loader">
          <div className="loadMessage">
            <div>
              <img src={logo} style={{ width: 500 }} alt="SchoolSims Logo" />
            </div>
            {!isTokenExpired && <h1>Loading Simulation...</h1>}
            {!isTokenExpired && (
              <Loader type="Bars" color="#272370" height={200} width={200} />
            )}
            {isTokenExpired && (
              <h2>
                Session has been expired. Please reopen the link to play
                simulation.
              </h2>
            )}
          </div>
        </div>
      )}

      {role && role === Roles.Client && !isSimPlayed && (
        <>
          <div className="bg-heading pt-3 pb-3">
            <img src={logo} style={{ width: 300 }} alt="SchoolSims Logo" />
          </div>
          <div className="text-center">
            <h2>Link expired please contact to the administrator!</h2>
          </div>
        </>
      )}
    </>
  );
};

export default SimLoading;
